import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { isEmpty, assign } from 'lodash-es';
import axios, { AxiosError } from 'axios';
import React, { useState, useCallback, useEffect } from 'react';
import { getErrorMessagesFromResponse } from '../../../../common/utils';
import { Alert } from '../../../../components/Alert';
import Button from '../../../../components/Button';
import FormGroup from '../../../../components/FormGroup';
const fetchPromoCode = AwesomeDebouncePromise(async (promoCode) => {
    if (!isEmpty(promoCode)) {
        return (await axios.get(`/api/promocode/search/${promoCode}`)).data;
    }
    return { code: '', discount_percentage: 0 };
}, 500);
export function PromoCodeField({ promoCode, updatePromoCode }) {
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState([]);
    const handleChange = useCallback((event) => {
        updatePromoCode(assign({}, promoCode, { code: event.target.value }));
    }, [updatePromoCode, promoCode]);
    const searchPromoCode = useCallback(async () => {
        try {
            setLoading(true);
            const availablePromoCode = await fetchPromoCode(promoCode.code);
            updatePromoCode({
                code: promoCode.code,
                discountPercentage: availablePromoCode.discount_percentage,
            });
            setErrors([]);
        }
        catch (error) {
            if (error instanceof AxiosError) {
                setErrors(getErrorMessagesFromResponse(error));
            }
            else if (error instanceof Error) {
                setErrors([error.message]);
            }
            else {
                setErrors(['Unknown Error']);
            }
            updatePromoCode({
                code: promoCode.code,
                discountPercentage: 0,
            });
            throw error;
        }
        finally {
            setLoading(false);
        }
    }, [promoCode, updatePromoCode, fetchPromoCode, setLoading]);
    useEffect(() => {
        searchPromoCode();
    }, [promoCode.code]);
    return (React.createElement("div", { className: 'payment-promo-code' },
        React.createElement(Alert, { type: "error", messages: errors }),
        React.createElement(FormGroup, null,
            React.createElement("input", { placeholder: 'Promo Code', onChange: handleChange, value: promoCode.code, type: 'text', className: 'form__control' }),
            React.createElement(Button, { type: "button", variant: "secondary", disabled: loading || isEmpty(promoCode.code), onClick: searchPromoCode }, "Apply"))));
}
